export enum EnumSistemas{
    RETAGUARDA_APP = 'b2a22b5d-b681-43e1-b110-44bc2f8809b9',
    PDV_APP = '31f2e5b0-1d29-48a3-9b85-8381699b0062',
    TOUCHONE = 'bd2d7c0c-1383-444f-8ddb-70047aade745',
    MOBILE = ''
}